module.exports = "/packs/media/images/icons/piechart-4d8c59858a05f6a6d2111cba392799f4.png";